/** Debounce after the most recent live-scene change before the leader checkpoints. */
export const COLLAB_AUTOSAVE_DELAY_MS = 30_000;
/** Defer a due checkpoint while relayed remote changes are still arriving. */
export const COLLAB_AUTOSAVE_REMOTE_QUIET_MS = 500;
/** Stop deferring for remote activity once the last successful save is this old. */
export const COLLAB_AUTOSAVE_MAX_STALENESS_MS = 2 * 60 * 1000;
/**
 * Elect the cloud-save leader from save-capable candidates: the lowest human
 * participant ID, or the lowest AI participant ID only when no human remains.
 */
export function electSaveLeader(candidates) {
    let human;
    let ai;
    for (const { participantId, ai: isAi } of candidates) {
        if (isAi) {
            if (ai === undefined || participantId < ai)
                ai = participantId;
        }
        else if (human === undefined || participantId < human) {
            human = participantId;
        }
    }
    return human ?? ai;
}
/** Explicitly synchronized save-capable candidates from a `USER_CHANGE` payload. */
export function saveLeaderCandidates(membership) {
    const ready = new Set((membership.participants ?? [])
        .filter((participant) => participant.synchronized === true)
        .map((participant) => participant.participantId));
    const aiIds = new Set((membership.participants ?? [])
        .filter((participant) => participant.identity?.kind === "ai")
        .map((participant) => participant.participantId));
    return membership.editorClientIds
        .filter((id) => ready.has(id))
        .map((participantId) => ({
        participantId,
        ai: aiIds.has(participantId),
    }));
}
/** Whether a due automatic checkpoint should wait for relayed remote changes to settle. */
export function shouldDeferAutosave(input) {
    return (input.now - input.lastRemoteChangeAt < COLLAB_AUTOSAVE_REMOTE_QUIET_MS &&
        input.now - input.lastSavedAt < COLLAB_AUTOSAVE_MAX_STALENESS_MS);
}
//# sourceMappingURL=collabSaveLeader.js.map